export enum PDxSystemSettingType {
    Boolean = 1,
    String,
    Integer,
    EncryptedString,
    WYSIWYG,
}

export class SettingInformation {
    keyName: string;
    originalValue: string;
    settingType: PDxSystemSettingType;
    editValue: any;
    displayValue: string;
    settingName: string;
}